const Dialog = function(dispatcher) {
    this.dialogs = {};
    this.eventConfirm = null;
    this.eventCancel = null;
    this.eventOk = null;
    this.eventSelection = null;
    this.eventOptions = null;

    this.init = () => {
        this.createConfirmDialog();
        this.createOkDialog();
        this.createSelectionDialog();
        this.createWaitingDialog();
        this.createBlankOverlay();

        dispatcher.on("dialog_confirm", (data) => {
            this.openConfirmDialog(data);
        });
        dispatcher.on("dialog_ok", (data) => {
            this.openOkDialog(data);
        });
        dispatcher.on("dialog_selection", (data) => {
            this.openSelectionDialog(data);
        });
        dispatcher.on("dialog_notification", (data) => {
            this.openFadingDialog(data);
        });
        dispatcher.on("dialog_waiting", (data) => {
            this.openWaitingDialog(data);
        });
        dispatcher.on("dialog_waiting-close", () => {
            this.closeWaitingDialog();
        });
    }

    this.openFadingDialog = (data) => {
        this.closeWaitingDialog();

        const collection = document.getElementsByClassName("fading-dialog");
        for (let i in collection) {
            const el = collection[i];
            if (el.style) {
                el.style.bottom = (parseInt(el.style.bottom) + 50) + "px";
            }
        }

        const dialog = document.createElement("div");
        dialog.setAttribute("style", "bottom: 50px;")
        dialog.setAttribute("class", "fading-dialog fade")
        dialog.innerHTML = data.body;
        setTimeout(function() {
            // this one is to hide message
            dialog.classList.toggle('fade');
        }, 5000);

        document.body.appendChild(dialog);
        setTimeout(function() {
            // this one is to show message
            dialog.classList.toggle('fade');
        }, 100);
    }

    this.closeConfirmDialog = () => {
        this.dialogs.confirm.style.display = "none";
        this.hideOverlay();
    }

    this.closeOkDialog = () => {
        this.dialogs.ok.style.display = "none";
        this.hideOverlay();
    }

    this.closeSelectionDialog = () => {
        this.dialogs.selection.style.display = "none";
        this.hideOverlay();
    }


    this.closeWaitingDialog = () => {
        this.dialogs.waiting.style.display = "none";
        this.hideOverlay();
    }

    this.openConfirmDialog = (data) => {
        this.closeWaitingDialog();
        const confirmText = data.confirm_text ? data.confirm_text : "Ok";
        const cancelText = data.cancel_text ? data.cancel_text : "Cancel";
        const titleText = data.title ? data.title : "";
        const bodyText = data.body ? data.body : "";
        const dialogClass = data.class ? data.class : "default-dialog";

        this.showOverlay();
        this.dialogs.confirm.classList.add('modal-visible', `${dialogClass}`);
        this.dialogs.confirm.querySelector(".dialog-confirm-header").innerHTML = titleText;
        this.dialogs.confirm.querySelector(".dialog-confirm-body").innerHTML = bodyText;
        this.dialogs.confirm.querySelector(".dialog-confirm-ok").innerHTML = confirmText;
        this.dialogs.confirm.querySelector(".dialog-confirm-cancel").innerHTML = cancelText;

        this.eventConfirm = data.confirm_event;
        this.eventCancel = data.cancel_event;
        this.eventOptions = data.options;

        this.dialogs.confirm.style.display = "";
    }
    this.openSelectionDialog = (data) => {
        this.closeWaitingDialog();
        const titleText = data.title ? data.title : "";
        const bodyText = data.body ? data.body : "";
        const footerText = data.footer ? data.footer: "";
        const dialogClass = data.class ? data.class : "default-dialog";

        this.showOverlay();
        this.dialogs.selection.classList.add('modal-visible', `${dialogClass}`);
        this.dialogs.selection.querySelector(".modal-selection-title > h5").innerHTML = titleText;
        this.dialogs.selection.querySelector(".dialog-selection-body").innerHTML = bodyText;
        this.dialogs.selection.querySelector(".dialog-selection-footer").innerHTML = footerText;

        this.eventSelection = data.ok_event;
        this.dialogs.selection.style.display = "";
    }

    this.openOkDialog = (data) => {
        this.closeWaitingDialog();
        const okText = data.ok_text ? data.ok_text : "OK";
        const titleText = data.title ? data.title : "";
        const bodyText = data.body ? data.body : "";
        const dialogClass = data.class ? data.class : "default-dialog";

        this.showOverlay();
        this.dialogs.ok.classList.add('modal-visible', `${dialogClass}`);
        this.dialogs.ok.querySelector(".dialog-ok-header").innerHTML = titleText;
        this.dialogs.ok.querySelector(".dialog-ok-body").innerHTML = bodyText;
        this.dialogs.ok.querySelector(".dialog-ok-ok").innerHTML = okText;

        this.eventOk = data.ok_event;
        this.eventOptions = data.options;

        this.dialogs.ok.style.display = "";
    }

    this.openWaitingDialog = (data) => {
        const titleText = data.title ? data.title : "";
        const dialogClass = data.class ? data.class : "default-dialog";

        this.showOverlay();
        this.dialogs.waiting.classList.add('modal-visible', `${dialogClass}`);
        this.dialogs.waiting.querySelector(".dialog-waiting-header").innerHTML = titleText;

        const bodyText = data.body_text ? data.body_text : "Loading";
        dispatcher.dispatch('spinner_show', {bodyText: bodyText, element: this.dialogs.waiting.querySelector(".dialog-waiting-body")});

        this.dialogs.waiting.style.display = "";
    }

    this.createBlankOverlay = () => {
        const overlayDiv = document.createElement("div");
        overlayDiv.setAttribute('id', 'mainOverlay');
        document.body.appendChild(overlayDiv);
    };

    this.showOverlay = () => {
        document.getElementById("mainOverlay").style.display = "block";
    };

    this.hideOverlay = () => {
        document.getElementById("mainOverlay").style.display = "none";
    };

    this.createConfirmDialog = () => {
        this.dialogs.confirm = document.createElement("div");
        this.dialogs.confirm.classList.add("modal", "modal-confirm");

        let html = `<div class='dialog-confirm-header'></div>
<div class='dialog-confirm-body'></div>
<div class='dialog-confirm-footer'>
    <button class="dialog-confirm-ok"></button>
    <button class="dialog-confirm-cancel"></button>
</div>`;
        this.dialogs.confirm.innerHTML = html;

        this.dialogs.confirm.querySelector(".dialog-confirm-ok").onclick = () => {
            this.closeConfirmDialog();
            if (this.eventConfirm) {
                dispatcher.dispatch(this.eventConfirm, this.eventOptions);
            }
        }
        this.dialogs.confirm.querySelector(".dialog-confirm-cancel").onclick = () => {
            this.closeConfirmDialog();
            if (this.eventCancel) {
                dispatcher.dispatch(this.eventCancel, this.eventOptions);
            }
        }

        document.body.appendChild(this.dialogs.confirm);
    }

    this.createSelectionDialog = () => {
        this.dialogs.selection = document.createElement("div");
        this.dialogs.selection.classList.add("modal", "modal-selection");

        let html = `<div class='dialog-selection-header'>
    <div class="modal-selection-title">
        <h5 class="title">It's Scary To Remarry</h5>
    </div>
    <div class="modal-selection-buttons">
        <button type="cancel" class="primary ui-btn dialog-selection-cancel">Cancel</button>
        <button type="submit" class="primary ui-btn dialog-selection-ok">OK</button>
    </div>
</div>
<div class='dialog-selection-body'></div>
<div id="dialogFooter" class='dialog-selection-footer'></div>`;
        this.dialogs.selection.innerHTML = html;
        this.dialogs.selection.querySelector(".dialog-selection-cancel").onclick = () => {
            this.closeSelectionDialog();
        }

        this.dialogs.selection.querySelector(".dialog-selection-ok").onclick = () => {
            this.closeSelectionDialog();
            const locationUrl = this.dialogs.selection.querySelector('input[type="radio"]:checked').value;

            if (this.eventSelection) {
                dispatcher.dispatch(this.eventSelection, {location: locationUrl});
            }
        }

        document.body.appendChild(this.dialogs.selection);
    }

    this.createOkDialog = () => {
        this.dialogs.ok = document.createElement("div");
        this.dialogs.ok.classList.add("modal", "modal-ok");

        let html = `<div class='dialog-ok-header'></div>
<div class='dialog-ok-body'></div>
<div class='dialog-ok-footer'>
    <button class="dialog-ok-ok"></button>
</div>`;
        this.dialogs.ok.innerHTML = html;

        this.dialogs.ok.querySelector(".dialog-ok-ok").onclick = () => {
            this.closeOkDialog();
            if (this.eventOk) {
                dispatcher.dispatch(this.eventOk, this.eventOptions);
            }
        }

        document.body.appendChild(this.dialogs.ok);
    }

    this.createWaitingDialog = () => {
        this.dialogs.waiting = document.createElement("div");
        this.dialogs.waiting.classList.add("modal", "modal-waiting");

        let html = `<div class='dialog-waiting-header'></div>
<div class='dialog-waiting-body'></div>
`;
        this.dialogs.waiting.innerHTML = html;

        document.body.appendChild(this.dialogs.waiting);
    }
};

export { Dialog }
